// initial state
const state = () => ({
    // 
})

// actions
const actions = {
    setupConnection: async ({ rootState, commit, dispatch }) => {
        console.log('SocketManager::setupConnection - setting up connection for user[' + rootState.auth.currentUser.id + ']');

        window.Echo.private('user.' + rootState.auth.currentUser.id)
            .listen('.socketPackage', (e) => {
                console.log("Package received", e);

                if (e.content.dispatch === undefined || e.content.dispatch === null || e.content.dispatch === '' || e.content.dispatch === false) {
                    // Call mutation from another module
                    commit(e.content.type + '/' + e.content.sub_type, e.content.body, { root: true });
                } else {
                    // Call action from another module
                    dispatch(e.content.type + '/' + e.content.sub_type, e.content.body, { root: true });
                }
            });
    },
}

// mutations
const mutations = {
}

export default {
    namespaced: true,
    state,
    // getters,
    actions,
    mutations
}
